import { ComponentType } from "react";
import {
  CustomerServiceOutlined,
  FileImageOutlined,
  FileOutlined,
  VideoCameraOutlined,
} from "@ant-design/icons";
import { IPendingUploadItem } from "../../types/interfaces";

/**
 * The upload panel's state colors (they replace the old percentage ramp). active: uploading or waiting,
 * butter. done: finished, mint. failed: needs the user, red. idle: cancelled by the user, the chip.
 */
export type UploadTone = "active" | "done" | "failed" | "idle";

export const UPLOAD_TONE_FILL: Record<UploadTone, string> = {
  active: "var(--st-butter)",
  done: "var(--st-mint)",
  failed: "var(--st-red)",
  idle: "var(--st-chip)",
};

/** A row with no status yet is treated as waiting, like its progress bar. */
export function uploadRowTone(status: IPendingUploadItem["status"]): UploadTone {
  if (status === "completed") return "done";
  if (status === "failed") return "failed";
  if (status === "cancelled") return "idle";
  return "active";
}

/** Butter while anything uploads; then red if one failed; then mint if one finished; else the chip. */
export function uploadPanelTone(uploads: Pick<IPendingUploadItem, "status">[]): UploadTone {
  if (uploads.some((u) => u.status === "uploading" || u.status === "pending")) return "active";
  if (uploads.some((u) => u.status === "failed")) return "failed";
  if (uploads.some((u) => u.status === "completed")) return "done";
  return "idle";
}

const IMAGE = ["jpg", "jpeg", "png", "gif", "webp"];
const VIDEO = ["mp4", "mov", "avi", "mkv", "webm"];
const AUDIO = ["mp3", "wav", "flac", "aac", "ogg"];

/** An Outlined file-type icon (the panel used emoji before). */
export function uploadFileIcon(fileName: string): ComponentType {
  const ext = (fileName.split(".").pop() || "").toLowerCase();
  if (IMAGE.indexOf(ext) !== -1) return FileImageOutlined;
  if (VIDEO.indexOf(ext) !== -1) return VideoCameraOutlined;
  if (AUDIO.indexOf(ext) !== -1) return CustomerServiceOutlined;
  return FileOutlined;
}
